'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".PudoCardList-module_pudoGroup__Zkt2w{display:flex;flex-direction:column;gap:8px;justify-content:stretch;justify-self:center;max-width:520px;width:100%}.PudoCardList-module_pudoExtraActions__R7F8x{margin-bottom:.5rem}.PudoCardList-module_pudoElmWrap__vfHE-{align-items:center;display:flex;flex-direction:column;justify-content:center;width:100%}";
var styles = {"pudoGroup":"PudoCardList-module_pudoGroup__Zkt2w","pudoExtraActions":"PudoCardList-module_pudoExtraActions__R7F8x","pudoElmWrap":"PudoCardList-module_pudoElmWrap__vfHE-"};
styleInject["default"](css_248z, 'a692696b-388a-47f0-aac2-5b33138611d6');

exports["default"] = styles;
